const tableOption = function () {
  return {
    stripe: true,
    page: true,
    maxHeight: "95%",
    header: false,
    index: true,
    selection: false,
    emptyText: "暂无数据",
    labelPosition: 'right',
    labelWidth: '100px',
    view: "详情",
    column: [
      {
        label: "上报编号",
        prop: "reportCode",
        search: true,
        clearable: true
      },
      {
        label: "任务编号",
        prop: "taskCode",
        search: true,
        clearable: true
      },
      {
        label: "任务名称",
        prop: "taskName",
        search: true,
        clearable: true
      },
      {
        label: "派发日期",
        prop: "createTime",
        search: true,
        clearable: true,
        type: "daterange"
      },
      {
        label: "任务状态",
        prop: "taskStates",
        search: true,
        clearable: true,
        type: "select",
        dicData: [
          {
            label: "待接单",
            value: 1
          },
          {
            label: "进行中",
            value: 2
          },
          {
            label: "待确认",
            value: 3
          },
          {
            label: "已完成",
            value: 4
          }
        ],
        formatter: function (row, value) {
          if (Number(value) === 1) {
            return "待接单";
          } else if (Number(value) === 2) {
            return "进行中";
          } else if (Number(value) === 3) {
            return "待确认";
          } else if (Number(value) === 4) {
            return "已完成";
          }
          return "";
        }
      },
      {
        label: "是否逾期",
        prop: "taskExceed",
        search: true,
        clearable: true,
        type: "select",
        dicData: [
          {
            label: "未逾期",
            value: 0
          },
          {
            label: "已逾期",
            value: 1
          }
        ],
        formatter: function (row, value) {
          if (Number(value) === 0) {
            return "未逾期";
          } else if (Number(value) === 1) {
            return "已逾期";
          }
          return "";
        }
      },
      {
        label: "紧急程度",
        prop: "taskLevel",
        search: true,
        clearable: true,
        type: "select",
        dicData: [
          {
            label: "特急",
            value: 1
          },
          {
            label: "紧急",
            value: 2
          },
          {
            label: "一般",
            value: 3
          }
        ],
        formatter: function (row, value) {
          if (Number(value) === 1) {
            return "特急";
          } else if (Number(value) === 2) {
            return "紧急";
          } else if (Number(value) === 3) {
            return "一般";
          }
          return "";
        }
      },
      {
        label: '处理要求',
        prop: 'taskAsk'
      },
      {
        label: '要求完成时间',
        prop: 'taskTime'
      },
      {
        label: '执行人员',
        prop: 'personName'
      }
    ]
  };
};

export default tableOption;
